<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{$t("navigations.site level kri summary")}}</h2>
    </div>
  </div>

  <div class="row g-3 mb-2">
    <div class="col-12 py-3">
      <div class="ibox-content mb-1 px-3 py-2">
        <div class="form-group mb-1">
         <div class="row my-2 align-items-end">

            <!-- Site Code -->
            <div class="col-12 col-lg-4 px-1">
              <label class="mb-0">Site Code</label>
              <select v-model="searchField.site" class="form-select">
                <option value="">{{ $t("navigations.all") }}</option>
                <option v-for="site in sites" :key="site.siteID" :value="site.siteID">
                  {{ site.siteCode }}
                </option>
              </select>
            </div>

            <!-- Risk Name -->
            <div class="col-12 col-lg-6 px-1">
              <label class="mb-0">Risk Name</label>
              <select class="form-select" v-model="searchField.riskName">
                <option value="">All</option>
                <option v-for="risk in allRiskNames" :key="risk" :value="risk">
                  {{ risk }}
                </option>
              </select>
            </div>
            <div class="col-12 col-lg-2 px-1">
              <span class="save_btn w-100 d-inline-block text-center" @click="searchReports">
                Search
              </span>
            </div>

          </div>

        </div>
      </div>
      <div class="ibox-body">
        <div class="ibox-title style_2 d-flex align-items-center justify-content-between">
          <h5> KRI Summary</h5>

         <div class="d-flex align-items-center">

            <!-- Create icon -->
            <div class="position-relative align-self-center">
              <img class="cursor-pointer" src="@/assets/img/create.png" width="17" height="17" alt="Create Threshold"
                @click="openRunKRIModal" />
              <div class="tool-tip">Run KRI</div>
            </div>
          </div>
        </div>


        <div class="ibox-content">
          <!-- Loader -->
          <div class="text-center" v-if="loading">
            <img src="../../assets/img/loading.gif" width="15" />
            <div>Please wait while the list is being loaded</div>
          </div>

          <!-- No data -->
          <div class="text-center" v-else-if="!reportList.length">
            No data available
          </div>

          <!-- Table -->
          <div v-else class="table-responsive custom-dark-table-wrapper table-scroll">
            <table class="table table-striped dark-table-head mb-0 fixed-column-table">
              <thead>
                <tr>
                  <th>Site Code</th>
                  <th>Risk Indicator</th>
                  <th>Derived Value</th>
                  <th>Unit/Unit Name</th>
                  <!-- <th>Data Scope</th> -->
                  <th class="text-center">Audit Trail</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in reportList" :key="item.id">
                  <td>{{ item.siteName }}</td>



                  <td>
                    {{ item.riskIndicator }}
                  </td>

                  <td>
                    {{ item.value }}

                  </td>
                  <td>{{ item.unit }}</td>
                  <!-- <td>{{ item.dataScope }}</td> -->
                  <td class="text-center">
                    <i class="fa fa-eye edit-delete" title="View Report" @click="viewDetails(item)"></i>
                  </td>

                </tr>
              </tbody>
            </table>
            <div class="row mt-2" v-if="totalPages > 1">
              <div class="col-12 d-flex justify-content-end">
                <v-pagination v-model="currentPage" :pages="totalPages" :range-size="1" active-color="#618bd7"
                  @update:modelValue="getReportList" />
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
  <ReportViewModal
  v-if="showViewModal"
  :data="selectedReport"
  @closeModal="closeViewModal"
/>
<RunKRIModal
  v-if="showRunKRIModal"
  @closeModal="closeRunKRIModal"
  @run-kri-success="getReportList"
/>

</template>


<script src="./RbqmStudySpecReport.js"></script>

<style scoped>
.table-scroll {
  max-height: 350px;
  /* scroll height */
  overflow-y: auto;
}

.status-badge {
  padding: 0.1rem 1rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
}

.custom-dark-table-wrapper {
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: middle;
  border-color: #dee2e6;
}

.dark-table-head>thead {
  --bs-table-accent-bg: hsl(205, 72%, 37%) !important;
  color: #ffffff !important;
}

.fixed-column-table {
  --last-col-width: 98px;
  --second-last-col-width: 80px;
  width: max-content;
  min-width: 100%;
}

.fixed-column-table th,
.fixed-column-table td {
  padding: 8px 12px;
  white-space: nowrap;
  background: #fff;
}

.fixed-column-table th:last-child,
.fixed-column-table td:last-child {
  width: var(--last-col-width);
  min-width: var(--last-col-width);
}

.fixed-column-table th:nth-last-child(2),
.fixed-column-table td:nth-last-child(2) {
  width: var(--second-last-col-width);
  min-width: var(--second-last-col-width);
}


.fixed-column-table thead th {
  position: sticky;
  top: 0;
  z-index: 4;
  background: #1a6aa2;
  color: #fff;
}

.fixed-column-table th:last-child,
.fixed-column-table td:last-child {
  position: sticky;
  right: 0;
  z-index: 3;
}

.fixed-column-table th:nth-last-child(2),
.fixed-column-table td:nth-last-child(2) {
  position: sticky;
  right: var(--last-col-width);
  z-index: 3;
}


.fixed-column-table thead th:last-child,
.fixed-column-table thead th:nth-last-child(2) {
  z-index: 5;
}

.custom-dark-table-wrapper {
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
}

.data-grid-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
  padding: 0.25rem 0rem;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: middle;
  border-color: #dee2e6;
}

.thead-primary {
  background-color: #0095ff !important;
  color: #ffffff !important;
}

.table-hover tbody tr:hover {
  background-color: rgba(209, 236, 255, 0.05);
}

.table .editable-cell {
  cursor: pointer;
  position: relative;
  outline: none !important;
}

.table .editable-cell:hover {
  background-color: rgba(255, 255, 0, 0.1);
}

.table .editable-cell:focus {
  background-color: rgba(255, 255, 0, 0.171);
  outline: none !important;
  box-shadow: none !important;
}
.form-select {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
